module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAABCAQAAACr1TyxAAAAEUlEQVQI12NkYGZgRYFsyDwABHYATANEE6YAAAAASUVORK5CYII="